import type { LucideIcon } from "lucide-react";

export function SignalChip({
  label,
  icon: Icon,
  className = "",
  delay = 0,
}: {
  label: string;
  icon?: LucideIcon;
  className?: string;
  delay?: number;
}) {
  return (
    <div
      className={`glass-pill px-3 py-2 inline-flex items-center gap-2 text-xs font-medium text-white/95 shadow-[0_8px_30px_rgba(123,63,242,0.25)] animate-float ${className}`}
      style={{ animationDelay: `${delay}s` }}
    >
      {Icon && (
        <span className="grid place-items-center size-5 rounded-full bg-gradient-to-br from-pink-soft to-violet text-white">
          <Icon className="size-3" />
        </span>
      )}
      <span className="whitespace-nowrap">{label}</span>
    </div>
  );
}
